import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { propertyData } from '../mockData';
import { Card, CardContent } from './ui/card';

const Specifications = () => {
  const { language } = useLanguage();
  const content = (propertyData[language] || propertyData.en).specifications;

  return (
    <section id="specifications" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-light text-slate-800 mb-12 text-center">
          {content.title}
        </h2>

        <Card className="max-w-4xl mx-auto shadow-xl border-none">
          <CardContent className="p-8">
            <div className="grid md:grid-cols-2 gap-6">
              {content.details.map((detail, index) => (
                <div
                  key={index}
                  className="flex flex-col p-4 rounded-lg bg-white border border-slate-200 hover:border-[#d4845f] transition-colors"
                >
                  <span className="text-sm text-slate-500 mb-2">
                    {detail.label}
                  </span>
                  <span className="text-lg font-semibold text-slate-800">
                    {detail.value}
                  </span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default Specifications;